<template>             
      <div ref="liste" class="liste fleet-search pa-2">        
        <v-list>   
      <auto-virtual-scroll-list v-resize="onResize" :totalHeight="height"
        :defaultHeight="36"
        :extra-items="5"
        style="width: 100%;">
          <fleet-search-line :fleet="fleet" v-for="fleet in filteredFleet" :key="fleet.FLE_ID"  />                  
      </auto-virtual-scroll-list>
    </v-list>
    </div>
</template>
<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'    
  import FleetState from './FleetState.vue'
  import FleetSearchLine from './FleetSearchLine.vue'

  @Component({
    name: 'FleetSearch', 
    props:{
      fleetid:Number
    },
    components:{FleetState,FleetSearchLine}
  })
  export default class FleetSearch extends Vue {      
    
    height = 100
    get filteredFleet(){
      return this.$store.myGetters.filteredFleet
    }

    
    mounted(){
      this.onResize()
    }
    
    onResize() {
        this.height = (this.$refs.liste as Element).clientHeight - 34       
    }                
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .line-item-state
  {
    display: inline-block;
    min-width: 40px;
  }
  .line-item-libelle{
     display: inline-block;
      min-width: 300px;
  }
  .fleet-search{
    background-color:#ddd;    
  }
  .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }
</style>